module.exports = __webpack_public_path__ + "img/f280-heating.33ef16d3.jpg";